import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Fade from "@mui/material/Fade";
import { DefaultPrimaryButton } from "@/styles/globalstyles";
import Copyright from "@/components/Copyright";
import { useEffect } from "react";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
        document.title = "404 Not Found | AMPA";
      }, []);

  const handleClick = () => {
    navigate("/", { replace: true });
  };

  return (
    <Fade in={true}>
      <Box
        sx={{
          display: "flex",
          width: { xs: "100%", sm: "100%" },
          height: { xs: "80vh", sm: "80vh" },
          alignItems: "center",
          justifyContent: "center",
          borderRadius: { xs: "10px", sm: "10px" },
          p: 4,
        }}
      >
        <Stack
          sx={{
            height: { xs: "100%", sm: "auto" },
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
        >
          <Typography variant="h1">404 Not found page</Typography>
          <Typography variant="h2">|</Typography>
          <Typography variant="h2">Please return to home page</Typography>

          <Button
            variant="contained"
            sx={{ ...DefaultPrimaryButton }}
            onClick={() => {
              handleClick();
            }}
          >
            Home
          </Button>
        </Stack>
        <Box sx={{ position: "absolute", bottom: 16 }}>
          <Copyright />
        </Box>
      </Box>
    </Fade>
  );
};

export default NotFound;
